import { updateTeacher } from '../../../modules/teacher/api';
import { UpdateTeacherPayload, Teacher } from '../../../modules/teacher/types';

export const updateTeacherUseCase = (teacherUuid: string, payload: UpdateTeacherPayload): Promise<Teacher> => {
  return updateTeacher(teacherUuid, payload);
};